import React from 'react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';

export const Header = ({ onOpenQuiz }) => {
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header 
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass border-b border-white/10' : 'bg-transparent'
      }`}
      data-testid="main-header"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Logo */}
          <div className="relative w-10 h-10">
            <div className="absolute inset-0 bg-gradient-to-tr from-[#00E599] via-[#00D4FF] to-[#00E599] rounded-lg rotate-45 opacity-20 blur-sm"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 32L20 8L32 32L28 32L20 18L12 32L8 32Z" fill="url(#gradient1)" />
                <path d="M16 26L20 18L24 26L22 26L20 22L18 26L16 26Z" fill="#00E599" />
                <defs>
                  <linearGradient id="gradient1" x1="8" y1="8" x2="32" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#00E599"/>
                    <stop offset="1" stopColor="#00D4FF"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
          <div className="flex flex-col -space-y-1">
            <span className="text-xl font-headline font-bold text-[#F4F4F5] tracking-tight">Smart Growth</span>
            <span className="text-xs font-accent text-[#00E599] tracking-widest">TECH</span>
          </div>
        </div>
        
        <nav className="hidden lg:flex items-center gap-8">
          <a 
            href="#how-it-works" 
            className="text-[#A1A1AA] hover:text-[#00E599] transition-colors text-sm font-body font-medium"
          >
            How It Works
          </a>
          <a 
            href="#integrations" 
            className="text-[#A1A1AA] hover:text-[#00E599] transition-colors text-sm font-body font-medium"
          >
            Integrations
          </a>
          <a 
            href="#roi-calculator" 
            className="text-[#A1A1AA] hover:text-[#00E599] transition-colors text-sm font-body font-medium"
          >
            ROI Calculator
          </a>
          <Button 
            onClick={onOpenQuiz}
            className="bg-[#00E599] hover:bg-[#00C985] text-[#050505] px-6 py-2.5 font-body font-semibold transition-all duration-300 hover:shadow-lg hover:shadow-[#00E599]/30 rounded-lg"
          >
            See the AI in Action
          </Button>
        </nav>

        {/* Mobile CTA */}
        <div className="lg:hidden">
          <a 
            href="tel:6027306385"
            className="flex items-center gap-2 bg-[#00E599] hover:bg-[#00C985] text-[#050505] px-4 py-2.5 font-body font-semibold transition-all duration-300 rounded-lg text-sm"
          >
            📞 Call Us
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
